let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8XqdL")).then(() => parcelRequire('dhIDr'));